import { SchemaTypes } from '@allesauto/graphql';
import translate from '@allesauto/i18n';
import { HeadlineVariation } from '@allesauto/utils/consts';
import { formatPrice } from '@allesauto/utils/funcs';
import { Add16 } from '@carbon/icons-react';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import Headline from '../headline';

interface AccessoriesExtras {
  name: string;
  price: number;
}

export interface AccessoriesProps {
  extras?: AccessoriesExtras;
  name: string;
  numOfProducts: number;
  price: number;
  dealer: string;
  delivery: string;
  sku: string;
  relatedProductSku: SchemaTypes.Maybe<string> | undefined;
}
[];

export interface CheckoutAccessoriesProps {
  checkoutAccessories: AccessoriesProps[];
}

const CheckoutAccessories: FC<CheckoutAccessoriesProps> = ({
  checkoutAccessories,
}) => {
  const groupedArray = [];

  for (const product of checkoutAccessories) {
    if (product.relatedProductSku !== null) {
      const relatedProductSku = product.relatedProductSku;
      const matchingProduct = checkoutAccessories.find(
        (p) => p.sku === relatedProductSku
      );

      if (matchingProduct) {
        const matchingIndex = groupedArray.findIndex((g) =>
          g.some((p) => p.sku === matchingProduct.sku)
        );

        if (matchingIndex > -1) {
          groupedArray[matchingIndex].push(product);
        } else {
          groupedArray.push([matchingProduct, product]);
        }
      }
    }
  }

  const totalAmount = checkoutAccessories.reduce<number>((acc, obj) => {
    return acc + obj.price;
  }, 0);

  const intl = useIntl();
  return (
    <div className="sm:p-15px lg:p-40px">
      <Headline
        className="pb-30px"
        headlineText={'Zubehör'}
        headlineTag={HeadlineVariation.H4}
      ></Headline>
      {checkoutAccessories &&
        groupedArray.map((accessoryGroup, index) => {
          return (
            <div key={index} className="border-b-1px border-grey30 mt-[24px]">
              {accessoryGroup.map((accessory, index) => {
                return (
                  <div key={index}>
                    <div className="flex justify-between mb-[8px]">
                      <span>
                        {accessory.numOfProducts + ' x ' + accessory.name}
                      </span>
                      <span>
                        {formatPrice(intl, accessory.price, {
                          withFractionDigits: true,
                        })}
                      </span>
                    </div>
                    {accessory.extras && (
                      <div className="flex justify-between pt-10px">
                        <div className="flex">
                          <span className="pr-5px pt-3px">
                            <Add16 />
                          </span>
                          <span>{accessory.extras?.name}</span>
                        </div>
                        <span>
                          {formatPrice(intl, accessory.extras?.price, {
                            withFractionDigits: true,
                          })}
                        </span>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          );
        })}
      <div className="flex justify-between mt-[24px] text-headline5">
        <span>{translate(intl, 'ui.PRICE.TOTAL_PRICE_ACCESSORY')}</span>
        <span>
          {formatPrice(intl, totalAmount, {
            withFractionDigits: true,
          })}
        </span>
      </div>
      <p className="mt-5px text-grey60 text-p2">
        {translate(intl, 'ui.PRICE.ALL_PRICES_INCLUDE_VAT')}
      </p>
    </div>
  );
};

export default CheckoutAccessories;
